import React, { Component } from 'react';
import './App.css';
import httpInterceptors from './interceptors';
import {BrowserRouter as Router} from "react-router-dom";
import {
  AppBar, Button,
  createTheme, Grid,
  CssBaseline, Tab, Tabs,
  Toolbar, Typography,
  styled
} from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import DataSetPage from "./DataSetPage";
import DashboardPage from "./DashboardPage";
import axios from "axios";


export interface AppProps {
}

const StyledApp = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  zIndex: 1,
  minWidth: '320px',
  backgroundColor: 'rgb(250, 250, 250)',
  
  '& .appFrame': {
    display: 'flex',
    width: '100%',
    height: '100vh',
    backgroundColor: 'rgb(250, 250, 250)',
  },
  
  '& .content': {
    overflow: 'auto',
    flexGrow: 1,
    paddingTop: 65,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: 'rgb(250, 250, 250)',
  },
  
  '& .innerContentRoot': {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 10,
    maxWidth: 1200,
  },
  
  '& .innerContentRootToolbar': {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 10,
    maxWidth: 1200,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  
  '& .error': {
    color: theme.palette.error.contrastText,
    marginTop: 1,
    marginBottom: 10,
    background: theme.palette.error.main,
    fontSize: '0.9375em',
    padding: 5,
    height: 70,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  },
  
  '& .sectionDesktop': {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  
  '& .toolbar': {
    background: '#BCE4FA',
    color: '#005B94'
  },
  
  '& .indicator': {
    background: '#005B94'
  },
}));

const APP_VERSION = process.env.REACT_APP_VERSION || '1.0';

const theme = createTheme({
  palette: {
    primary: {
      main: '#005B94',
      contrastText: '#fff',
      dark: '#5eb8d6',
      light: '#BCE4FA'
    },
    secondary: {
      main: '#FFFFFF'
    }
  }
});

class App extends Component<AppProps> {

  state = {
    authenticated: false,
    authentication_failed: false,
    selectedTab: "dashboard"
  };

  componentDidMount() {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    httpInterceptors.setupAxiosInterceptors();

    if (window.location && window.location.hash) {
      let normalizedHash = window.location.hash.replace('#', '');
      if (normalizedHash.length > 0) {
        const params = new URLSearchParams(normalizedHash);
        if (params) {
          let accessTokenValue = params.get('access_token');
          if (accessTokenValue) {
            localStorage.setItem('access-token', accessTokenValue);
            axios.defaults.headers.common.Authorization = `Bearer ${accessTokenValue}`;
            window.location.replace('/');
            return;
          } else {
            let error = params.get('error');
            if (error) {
              this.setState({authentication_failed: true});
              return;
            }
          }
        }
      }
    }

    if (localStorage.getItem('access-token')) {
      axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('access-token')}`;
      if (this.state.authenticated === false) {
        this.checkAccessToken();
      }
    } else {
      this.redirectToAuthentication();
    }
  }

  async checkAccessToken() {
    try {
      await axios.get('/api/admin/datasets#checking_token=true');
      this.setState({authenticated: true});
    } catch (error) {
      localStorage.removeItem('access-token');
      axios.defaults.headers.common.Authorization = null;
      this.setState({authentication_failed: true});
    }
  }

  handleTabChange = (event: any, value: string) => {
    this.setState({ selectedTab: value });
  };

  redirectToAuthentication() {
    if (window.location.href === `${process.env.REACT_APP_AUTHENTICATION_URL}`) {
      window.location.reload();
    } else {
      window.location.replace(`${process.env.REACT_APP_AUTHENTICATION_URL}`)
    }
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline/>
        <Router>
          <StyledApp className="root">
            <div className="appFrame">
              <AppBar position='fixed'>
                <Toolbar className="toolbar">
                  <div className="innerContentRootToolbar">
                    {this.state.authenticated &&
                    <Tabs className="toolbar" value={this.state.selectedTab} onChange={this.handleTabChange}
                          sx={{ '& .MuiTabs-indicator': { background: '#005B94' } }}>

                        <Tab value={"dashboard"} label="Übersicht"/>
                        <Tab value={"datasets"} label="Datensätze"/>
                    </Tabs>
                    }
                    {!this.state.authenticated &&
                      <div className="toolbar">&nbsp;</div>
                    }

                  <div className="sectionDesktop">
                    <Grid container justifyContent="center" direction="row" spacing={2}>
                      <Grid item>
                        <Grid container justifyContent="center" direction="column" alignItems="flex-end">
                          <Grid item>
                            <Typography variant="h6" color="inherit" noWrap>
                              sCall Admin
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="inherit" noWrap>
                              Version {APP_VERSION}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                  </div>
                </Toolbar>

              </AppBar>

              <main className="content">
                { this.state.authentication_failed &&

                <div className="innerContentRoot">
                    <div className="error" style={{marginTop: '50px'}}>Bei der Anmeldung ist ein Fehler aufgetreten - möglicherweise besitzen Sie nicht die notwendigen Rechte, um die sCall-Administrationsoberfläche zu verwenden</div>
                  <Grid container alignContent={"center"} justifyContent={"center"}>
                    <Grid item>
                    <Button color={"primary"} variant={"contained"} onClick={() => {
                      this.redirectToAuthentication();
                    }}>
                        Anmeldung erneut versuchen
                    </Button>
                    </Grid>
                  </Grid>
                </div>
                }

                { (this.state.authenticated && this.state.selectedTab === "dashboard") &&
                          <DashboardPage/>
                }

                { (this.state.authenticated && this.state.selectedTab === "datasets") &&
                  <DataSetPage/>
                }
              </main>



            </div>
          </StyledApp>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;
